import { useParkingSpaceEnum } from '@services/device'
import { Select, SelectProps } from '@shared/Form/Select'
import React from 'react'

type Props = SelectProps

export const ParkingSpaceTypeSelect = React.forwardRef<typeof Select, Props>(
  (props, ref): any => {
    const { data } = useParkingSpaceEnum()

    return (
      <Select {...props}>
        {data.map(item => (
          <Select.Option key={item.key} value={item.key}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    )
  }
)

export default ParkingSpaceTypeSelect
